import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import MessageCard from "../../../components/AdminCards/MessageCard";
import handleCSRF from "../../../config/CSRF";

function LoyaltyPoints() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState();
  const [formData, setFormData] = useState({
    name: "",
    convert_points: "0",
    per_price: "",
    percentage_order_amount: "",
    minimum_point: "",
    status: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${apiKey}/api/rms/admin/loyalty`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.details, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setPageLoading(true);
    const fetchData = () => {
      axios
        .get(`${apiKey}/api/rms/admin/loyalty`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data[0]);
        })
        .catch((err) => {
          setError(err.response.data.message);
        })
        .finally(() => {
          setPageLoading(false);
        });
    };

    handleCSRF(fetchData);
  }, [user?.token]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Loyalty Points</h1>
          </div>
        </div>

        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Status
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="status"
                    id="status_active"
                    value={1}
                    onChange={handleChange}
                    checked={parseInt(formData.status) === 1}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-[#7B20C7] text-sm mb-2 "
                    htmlFor="status_active"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="status"
                    id="status_inactive"
                    value={0}
                    onChange={handleChange}
                    checked={parseInt(formData.status) === 0}
                  />
                  <label
                    className="form-check-label ps-3 text-[#7B20C7] text-sm mb-2"
                    htmlFor="status_inactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-2/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative">
                  Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-2/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative">
                  1 SAR = How Much Point
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Convert Points"
                    name="per_price"
                    onChange={handleChange}
                    value={formData.per_price}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-2/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative">
                  Percentage Of Loyalty Point On Order Amount
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Percentage Of Loyalty Point On Order Amount "
                    name="percentage_order_amount"
                    onChange={handleChange}
                    value={formData.percentage_order_amount}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-2/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative">
                  Minimum Point To Transfer
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Minimum Point To Transfer "
                    name="minimum_point"
                    value={formData.minimum_point}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

export default LoyaltyPoints;
